import moment from 'jalali-moment';

export class PersianDate {
    private months: { [key: string]: string } = {
        '01': 'فروردین',
        '02': 'اردیبهشت',
        '03': 'خرداد',
        '04': 'تیر',
        '05': 'مرداد',
        '06': 'شهریور',
        '07': 'مهر',
        '08': 'آبان',
        '09': 'آذر',
        '10': 'دی',
        '11': 'بهمن',
        '12': 'اسفند',
    };

    /**
     * Converts a UTC timestamp to Jalali date format with Persian month names.
     * @param utcDateTime - ISO 8601 UTC timestamp (e.g., '2023-09-19T06:55:09.586Z')
     * @returns Formatted string (e.g., '28 شهریور 1402')
     */
    convert(utcDateTime: string, full = false): string {
        try {
            // Validate input
            if (!moment(utcDateTime, moment.ISO_8601, true).isValid()) {
                throw new Error('Invalid UTC timestamp');
            }

            // Parse UTC timestamp and convert to Iran timezone (UTC+3:30)
            const date = moment(utcDateTime).utcOffset('+0330').locale('fa');
            // Format as Jalali date
            const day = date.format('DD');
            const month = this.months[date.format('MM')] || 'نامشخص';
            const year = date.format('YYYY');
            const time = date.format('HH:mm:ss');

            if(full) {
                return `${time} / ${day} ${month} ${year}`;
            } else {
                return `${day} ${month} ${year}`;
            }
        } catch (error: unknown) {
            console.error('Error converting date:', (error as Error).message);
            return 'Invalid Date';
        }
    }
}